import React from 'react';
import { NavBarTrigger, NavBarTriggerProps } from './NavBarTrigger';

export const PageNavBarTrigger = (props: NavBarTriggerProps) => (
  <NavBarTrigger type="page" {...props} />
);
